<template>
    <div class="container">
        <div class="paramForm">
            <el-button type="primary" icon="el-icon-refresh" @click="handleSearch">刷新</el-button>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-finished" @click="syncApi">同步权限</el-button>
        </div>
        <el-table border :data="apiList" style="width: 100%" row-key="id" lazy :load="loadChild" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
            <!-- <el-table-column prop="id" align="center" label="ID"  width="100"></el-table-column> -->
            <el-table-column prop="name" label="资源名称" width="400"></el-table-column>
            <el-table-column prop="code" label="资源权限编码" width="400"></el-table-column>
            <el-table-column prop="url" label="URL"></el-table-column>
            <el-table-column label="创建时间" align="center" width="150">
                <template slot-scope="scope">{{ scope.row.createdAt }}</template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { apiServiceApi } from '@/api/api-auth';
export default {
    data() {
        return {
            loading: false,
            apiList: [],
        };
    },
    created() {
        this.handleSearch();
    },
    methods: {
        handleSearch() {
            this.apiList = [];
            apiServiceApi.findList({}).then(res => {
                this.apiList = res;
            });
        },
        syncApi() {
            this.loading = true;
            apiServiceApi.sync().then(res => {
                this.loading = false;
                this.handleSearch();
            })
        },
        loadChild(node, tree, resolve) {
            if (node && node.code) {
                apiServiceApi.findList({ parentCode:node.code}).then(res => {
                    resolve(res);
                });
            } else {
                resolve([]);
            }
        }
    }
};
</script>